<template>
  <div class="container">
    <div class="page-title">邀请码列表</div>
    <div style="display: flex;margin-left: 20px;margin-top: 10px;">
      <el-button type="primary" icon="el-icon-folder-add" @click="create">生成验证码</el-button>
    </div>
    <div class="content">
      <template>
        <el-table
          :data="tableData"
          border
          style="width:100%;flex:1;overflow:auto;"
          v-loading="listLoading"
        >
          <el-table-column
            prop="code"
            label="邀请码"
            width="160">
          </el-table-column>
          <el-table-column
            prop="phone"
            label="手机号"
            width="160">
          </el-table-column>
          <el-table-column
            prop="companyName"
            label="公司名称"
            width="160">
          </el-table-column>
          <el-table-column
            prop="name"
            label="法人"
            width="160">
          </el-table-column>
          <el-table-column
            label="到期时间"
            width="160">
            <template slot-scope="scope">
              {{ scope.row.endTime | rTime }}
            </template>
          </el-table-column>
          <el-table-column
            label="创建时间"
            width="160">
            <template slot-scope="scope">
              {{ scope.row.createTime | rTime }}
            </template>
          </el-table-column>
          <el-table-column
            label="使用状态"
            width="160">
            <template slot-scope="scope">
              {{ scope.row.userFlag ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="160">
            <template slot-scope="scope">
              <div style="display: flex;align-items: center;">
                <el-button @click="copy(scope.row.id)" size="small" type="primary">复制</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </div>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      :page-sizes="[5, 10, 20, 40]"
      layout="total, sizes, prev, pager, next, jumper"
      background
      :total="total"
    ></el-pagination>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        tableData: [],
        ifSuccNotice: false,
        textarea: '',
        orderNumber: '',
        checkboxGroup: [],
        activeName: 'second',
        options: [],
        username: '',
        wechat: '',
        qq: '',
        phone: '',
        role:'', //岗位
        value: '',
        dialogTableVisible: false,
        total: 0,
        pageSize: 10,
        currentPage:1,
        listLoading: false,
        accessConfig: {}
      };
    },
    activated () {
      this.queryData(this.currentPage,this.pageSize);
    },
    methods: {
      queryData(currentPage,pageSize){
        this.listLoading = true;
        this.$http.post(`/user/verificationCodePage/${currentPage}/${pageSize}`, {  }, { headers: {
            token: window.sessionStorage.manageToken
          }})
          .then(res => {
            this.listLoading = false;
            if (res.data.code === 'ok') {
              console.log('resdatadata====',res.data.data)
              this.tableData = res.data.data.list;
              this.total = res.data.data.total;
            } else {
              this.$message.error(res.data.data)
            }
          });
      },
      handleSizeChange: function (size) {
        this.pageSize = size;
        console.log(this.pageSize);  //每页下拉显示数据
        this.queryData(this.currentPage,this.pageSize);
      },
      handleCurrentChange: function(currentPage){
        this.currentPage = currentPage;
        console.log(this.currentPage);  //点击第几页
        this.queryData(this.currentPage,this.pageSize);
      },
      handleClick(tab, event) {
        console.log(tab, event);
      },
      create(){
        this.listLoading = true;
        this.$http.post(`/user/getVerificationCode`, {  }, { headers: {
            token: window.sessionStorage.manageToken
          }})
          .then(res => {
            this.listLoading = false;
            if (res.data.code === 'ok') {
              this.currentPage = 1;
              this.queryData(this.currentPage,this.pageSize);
            } else {
              this.$message.error(res.data.data)
            }
          });
      },
      copy(id){
        this.listLoading = true;
        this.$http.post(`/user/copyVerificationMessage?id=${id}`, {  }, { headers: {
            token: window.sessionStorage.manageToken
          }})
          .then(res => {
            this.listLoading = false;
            if (res.data.code === 'ok') {
              let _this = this;
              this.$copyText(res.data.data).then(function (e) {
                _this.$message({
                  showClose: true,
                  message: "复制成功",
                  type: "success"
                });
              }, function (e) {
                _this.$message({
                  showClose: true,
                  message: "复制失败",
                  type: "error"
                });
              })
            } else {
              this.$message.error(res.data.data)
            }
          });
      },
      queryOptions(){
        this.$http.post("/user/findRole", {}, { headers: {
            token: window.sessionStorage.manageToken
          }})
          .then(res => {
            console.log('res====',res)
            if (res.data.code === 'ok') {
              console.log('resdatadata====',res.data.data)
              this.options = res.data.data;
              this.dialogTableVisible = true;
            } else {
              this.$message.error(res.data.data)
            }
          });

      },
      confirm(){
        this.$http.post("/user/saveManager", {
          username: this.username,
          wechat: this.wechat,
          qq: this.qq,
          phone: this.phone,
          role: this.role,
          password: '123456'
        }, { headers: {
            token: window.sessionStorage.manageToken
          }})
          .then(res => {
            console.log('res====',res)
            if (res.data.code === 'ok') {
              console.log('resdatadata====',res.data.data)
              this.dialogTableVisible = false;
              this.$message({
                showClose: true,
                message: res.data.data,
                type: 'success'
              });
              this.username = '';
              this.wechat = '';
              this.qq = '';
              this.phone = '';
              this.role = '';
              this.queryData(this.currentPage,this.pageSize);
            } else {
              this.$message.error(res.data.data)
            }
          });
      }
    },
    filters: {
      rTime(data) {
        if(!data) return
        var dt = new Date(data);
        var y = dt.getFullYear();
        var m = (dt.getMonth()+1).toString().padStart(2,"0");
        var d = dt.getDate().toString().padStart(2,"0");
        var h = dt.getHours().toString().padStart(2,"0");
        var mm = dt.getMinutes().toString().padStart(2,"0");
        var s = dt.getSeconds().toString().padStart(2,"0");
        return `${y}-${m}-${d} ${h}:${mm}:${s}`;
      }
    }
  };
</script>
<style lang="less" scoped>
  .container {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
  }
  .date-box {
    display: flex;
    align-items: center;
    padding-left: 12px;
    margin-bottom: 20px;
  }
  .content {
    /*display: flex;*/
    /*flex-direction: column;*/
    display: flex;
    flex-direction: column;
    overflow: auto;
    flex: 1;
    margin-top: 10px;
    .first-line {
      display: flex;
      justify-content: flex-start;
      margin-bottom: 20px;
    }
    .label {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      /*text-align: right;*/
      font-size: 10px;
      color: #000000;
      padding-right: 10px;
      min-width: 60px;
    }

  }
</style>
